.monaco-editor .lines-content .core-guide{box-sizing:border-box;height:100%;position:absolute}